import { useQuery } from "@apollo/client";
import { UserType } from "../../../gql/__generated__/graphql";
import { GET_COLLABS_FOR_USER } from "../../apis/lambda/GraphQL/Collab/queries";

interface ActionRequiredCounts {
  pending: number;
  accepted: number;
  reviewing: number;
  history: number;
}

export const useCollabs = (role: UserType) => {
  // Use GraphQL query
  const { data, loading, error } = useQuery(GET_COLLABS_FOR_USER);

  const collabs = data?.getCollabsForUser || [];

  // Filter collabs by status
  const pendingCollabs = collabs.filter(
    (collab) => collab.status === "PENDING" || collab.status === "DISCUSSING"
  );
  const acceptedCollabs = collabs.filter(
    (collab) =>
      collab.status === "ACCEPTED" || collab.status === "AWAITING_FUNDING"
  );
  const reviewingCollabs = collabs.filter(
    (collab) =>
      collab.status === "CONTENT_SUBMITTED" ||
      collab.status === "AWAITING_TRANSFER" ||
      collab.status === "CHANGES_REQUESTED"
  );
  const historyCollabs = collabs.filter(
    (collab) => collab.status === "COMPLETED" || collab.status === "DECLINED"
  );

  // Count collabs that require action from the current user
  const actionRequiredCounts: ActionRequiredCounts = {
    pending: pendingCollabs.filter(
      (collab) =>
        (role === "BRAND_USER" && collab.actionRequiredBy === "BRAND_USER") ||
        (role === "CREATOR" && collab.actionRequiredBy === "CREATOR")
    ).length,
    accepted: acceptedCollabs.filter(
      (collab) =>
        (role === "BRAND_USER" && collab.actionRequiredBy === "BRAND_USER") ||
        (role === "CREATOR" && collab.actionRequiredBy === "CREATOR")
    ).length,
    reviewing: reviewingCollabs.filter(
      (collab) =>
        (role === "BRAND_USER" && collab.actionRequiredBy === "BRAND_USER") ||
        (role === "CREATOR" && collab.actionRequiredBy === "CREATOR")
    ).length,
    history: historyCollabs.filter(
      (collab) =>
        (role === "BRAND_USER" && collab.actionRequiredBy === "BRAND_USER") ||
        (role === "CREATOR" && collab.actionRequiredBy === "CREATOR")
    ).length,
  };

  return {
    pendingCollabs,
    acceptedCollabs,
    reviewingCollabs,
    historyCollabs,
    actionRequiredCounts,
    loading,
    error,
  };
};
